import axios from "../utils/axios";


export const getBreakdownReasonGroupList = () => {
    return axios.get(`BreakdownReasonGroup/GetList`);
};

export const addBreakdownReasonGroup = (data) => {
    return axios.post(`/BreakdownReasonGroup/Add`, data);
};

export const updateBreakdownReasonGroup = (data) => {
    return axios.post(`/BreakdownReasonGroup/Update`, data);
};

export const deleteBreakdownReasonGroup = (payload) => {
    return axios.post(`/BreakdownReasonGroup/Delete`, payload);
};
